import React, { useState, useCallback } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const RconDirectConnect = ({ onDirectConnect, disabled = false }) => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  const [port, setPort] = useState('25575');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    if (!port || !password || disabled) return;
    onDirectConnect(parseInt(port, 10), password);
  }, [port, password, disabled, onDirectConnect]);

  return (
    <div className="rcon-card">
      <div className="card-heading">
        <div className="card-title-wrap">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
          </svg>
          <h3 className="card-title">
            {isEn ? 'Direct Connection' : 'Прямое подключение'}
          </h3>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="direct-connect-grid">
          <div className="field-group">
            <label className="field-label">
              {isEn ? 'RCON PORT' : 'Порт RCON'}
            </label>
            <div className="field-input-wrapper">
              <input
                type="number"
                className="field-input"
                value={port}
                onChange={(e) => setPort(e.target.value)}
                min="1"
                max="65535"
                required
                disabled={disabled}
              />
            </div>
          </div>

          <div className="field-group">
            <label className="field-label">
              {isEn ? 'RCON PASSWORD' : 'Пароль RCON'}
            </label>
            <div className="field-input-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                className="field-input"
                placeholder={isEn ? 'Enter password...' : 'Введите пароль...'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={disabled}
              />
              <button
                type="button"
                className="toggle-pwd-btn"
                onClick={() => setShowPassword(v => !v)}
                title={showPassword ? (isEn ? 'Hide password' : 'Скрыть пароль') : (isEn ? 'Show password' : 'Показать пароль')}
              >
                {showPassword ? (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                    <line x1="1" y1="1" x2="23" y2="23" />
                  </svg>
                ) : (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>

        <button
          type="submit"
          className="btn-direct-submit"
          disabled={disabled || !port || !password}
        >
          <span>{isEn ? 'Connect Directly' : 'Подключиться напрямую'}</span>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </form>
    </div>
  );
};

export default RconDirectConnect;
